module.exports = require('./helpers/bundle-url').getBundleURL('cweZv') + "logo.c51670a8.svg";